import { Line }   from "../../planner_base";
import { LineCalendarCell, LineMenu } from "../model";
import watch from "redux-watch";
import isEqual from 'is-equal';
import { PLANNER_CLICK_LINE_MENU } from 'apps/events';

class Menu extends Line {
  onClickMenu(e){
    e.preventUpdate = true;
    let element:HTMLElement = <HTMLElement>this.querySelector('.btn-menu');
    let lineMenu = new LineMenu(this.opts.id, element);
    let customEvent:CustomEvent = new CustomEvent(PLANNER_CLICK_LINE_MENU, {detail: lineMenu})
    document.dispatchEvent(customEvent);
  }
}
riot.mixin('orders.planner.line-ui.menu', Menu as riot.TagMixin)
